import './js/main';
import './app.scss'

$(() => {
    const $langBox = $('.plug__text-lang');
    const maxIndex = _.max($langBox.map((index, el) => {
        return parseInt($(el).data('index')) || 0
    }))

    const minIndex = _.min($langBox.map((index, el) => {
        return parseInt($(el).data('index')) || 0
    }))

    if (maxIndex > 0 && minIndex > 0) {
        const rangeIndex = _.range(minIndex, maxIndex + 1)
        const langsMap = {};
        for (let index of rangeIndex) {
            langsMap[index] = $langBox.filter(function () {
                return parseInt($(this).data('index')) === index
            })
        }

        let currentLang = minIndex;

        const changeLang = () => {
            const $activeLang = $langBox.filter('.active')
            $activeLang.removeClass('hidden').removeClass('active')
            for (const [langIndex, langEls] of Object.entries(langsMap)) {
                if (parseInt(langIndex) === parseInt(currentLang)) {
                    langEls.addClass('active')
                    setTimeout(() => {
                        langEls.removeClass('hidden')
                        $activeLang.addClass('hidden')
                    }, 1000)
                }
            }

            currentLang += 1;
            if (currentLang > maxIndex) {
                currentLang = minIndex
            }
            setTimeout(changeLang, 7000);
        }

        if (minIndex < maxIndex) {
            setTimeout(function () {
                currentLang = _.min([currentLang, maxIndex]) + 1
                changeLang();
            }, 6000);
        }
    }
})

$(window).on('load', function() {
    setTimeout(function() {
        $('.js-preloader-region').addClass('hide')
    }, 500)
})
